import { AnyAction } from 'redux';
import { jobsTypes } from '../../../../redux/jobs';
import { offlineTypes } from '../../../../redux/offline';

export type SubmitFeedbackStatus = 'idle' | 'sending' | 'success' | 'pending' | 'error';

export const getSubmitFeedbackStatusFromAction = (jobId: string, action: AnyAction): Exclude<SubmitFeedbackStatus, 'idle' | 'sending'> | undefined => {
    if (action.type === jobsTypes.SEND_METER_TASK_RESULT_DONE && action.jobId === jobId) {
        return 'success';
    }

    if (action.type === jobsTypes.SEND_METER_TASK_RESULT_ERROR && action.jobId === jobId) {
        return 'error';
    }

    if (action.type === offlineTypes.QUEUE_ACTION && action.action?.type === jobsTypes.SEND_METER_TASK_RESULTS && action.action?.jobId === jobId) {
        return 'pending';
    }

    return undefined;
};

export const shouldShowSubmitResultView = (submitFeedbackStatus: SubmitFeedbackStatus) =>
    submitFeedbackStatus === 'success' || submitFeedbackStatus === 'pending';

export const shouldShowLegacyDoneView = ({
    jobDone,
    submitFeedbackStatus,
}: {
    jobDone: boolean;
    submitFeedbackStatus: SubmitFeedbackStatus;
}) => jobDone && submitFeedbackStatus === 'idle';

export const shouldShowLegacyPendingView = ({
    isJobPending,
    jobDone,
    submitFeedbackStatus,
}: {
    isJobPending: boolean;
    jobDone: boolean;
    submitFeedbackStatus: SubmitFeedbackStatus;
}) => isJobPending && !jobDone && submitFeedbackStatus === 'idle';
